import { UserRole } from "@shared/enums/UserRole";
import { UserModel } from "@shared/models/userModels";

const rolesHierarchy = [
  UserRole.User,
  UserRole.Organisational_Administrator,
  UserRole.Administrator,
  UserRole.Super_Admin,
];

export const checkMinPrivileges = (role: UserRole, userData: UserModel | undefined): boolean => {
  if (!(!!role && userData)) return false;

  const roleIndex = rolesHierarchy.indexOf(role);
  return userData.roles.some((role) => rolesHierarchy.indexOf(role) >= roleIndex);
};
